import  { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { fetchWithAuth } from '../utils/apiClient'

export const LIVE_LOAD_FETCHING_KEY = 'loadboard:extensionFilterSyncEnabled'

const MeContext = createContext({
	me: null,
	loading: true,
	error: null,
	refresh: () => {},
})

export function MeProvider({ children }) {
	const [me, setMe] = useState(null)
	const [loading, setLoading] = useState(true)
	const [error, setError] = useState(null)

	const refresh = useCallback(async (isActive = () => true) => {
		try {
			setError(null)
			const res = await fetchWithAuth('/api/me')
			if (!isActive()) return
			if (!res.ok) throw new Error(`Could not load profile (${res.status})`)
			const data = await res.json()
			if (!isActive()) return
			localStorage.setItem(
				LIVE_LOAD_FETCHING_KEY,
				String(data.liveLoadFetching !== false),
			)
			setMe(data)
		} catch (err) {
			if (!isActive()) return
			setError(err)
			setMe(null)
		} finally {
			if (isActive()) setLoading(false)
		}
	}, [])

	useEffect(() => {
		let active = true
		refresh(() => active)
		return () => { active = false }
	}, [refresh])

	return (
		<MeContext.Provider value={{ me, loading, error, refresh }}>
			{children}
		</MeContext.Provider>
	)
}

export function useMe() {
	return useContext(MeContext)
}
